/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateClientRequest { 
    name: string;
    description?: string;
    taxId?: string;
    showTags: boolean;
    showSentiment: boolean;
    newAnalytics: boolean;
    lang: UpdateClientRequest.LangEnum;
    foreignCountry: boolean;
    lastClippingReportSentAt?: Date;
    lastBiReportSentAt?: Date;
    resellerId: string;
}
export namespace UpdateClientRequest {
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}